import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Authorization } from "../../common/AuthorizationCpt";
import { BETA_FEATURES } from "../../utils/constants";
import { USER_ROUTES } from "../../utils/routeConstants";
import Dropdown from "./Dropdown";
import {
  Container,
  SubItem,
  UnorderedList,
  UserButton,
} from "./SideMenuStyles";

function UserSideMenu(props: any) {
  const { userInfo } = props;
  const history = useHistory();
  const [pathname, setPathname] = useState(history.location.pathname);

  useEffect(() => {
    const unsub = history.listen((location) => {
      setPathname(location.pathname);
    });
    return () => {
      unsub();
    };
  }, [history]);

  const isBillingUsersAgentActive =
    pathname === USER_ROUTES.ORDERS.path ||
    pathname === USER_ROUTES.PAYMENT.path ||
    pathname === USER_ROUTES.DATES.path ||
    pathname === USER_ROUTES.CREATE_QUOTES.path ||
    pathname === USER_ROUTES.DATING_TRACKING.path ||
    pathname === USER_ROUTES.PAYMENT_PRE_BILLS.path ||
    pathname === USER_ROUTES.PAYMENT_VALIDATION_STATUS.path ||
    pathname === USER_ROUTES.CREATING_QUOTES.path ||
    pathname === USER_ROUTES.INVOICED_PAYMENTS.path;
  return (
    <Container>
      <UnorderedList>
        <Dropdown title="Gestión de despacho">
          <Authorization
            actions={[
              "appointment.get_appointments",
              "volante.get_volante_appointment",
              "dam.get_dam_estimate_intranet",
              "quotation.get_quotation_paid",
              "quotation.get_quotation_pending",
              "quotation.get_quotation_quoted",
            ]}
          >
            <SubItem>
              <UserButton
                isActive={isBillingUsersAgentActive}
                onClick={() => {
                  if (userInfo.profile.name === "Tesorero") {
                    history.push(USER_ROUTES.PAYMENT_PRE_BILLS.path);
                  } else if (userInfo.profile.name === "Despachador") {
                    history.push(USER_ROUTES.CREATE_QUOTES.path);
                  } else {
                    history.push(USER_ROUTES.ORDERS.path);
                  }
                }}
              >
                {USER_ROUTES.BILLING_USERS_AGENT.title}
              </UserButton>
            </SubItem>
          </Authorization>
          <Authorization
            actions={[
              "dam.get_dam_senasa_agent",
              "dam.get_dam_electronic_mandate_agent",
              "volante.get_volante_third_party_auth",
              "invoice.get_invoice_payment_status",
            ]}
          >
            <SubItem>
              <UserButton
                isActive={pathname === USER_ROUTES.DOCUMENT_VALIDATION.path}
                onClick={() => {
                  history.push(USER_ROUTES.DOCUMENT_VALIDATION.path);
                }}
              >
                {USER_ROUTES.DOCUMENT_VALIDATION.title}
              </UserButton>
            </SubItem>
          </Authorization>
        </Dropdown>
        {BETA_FEATURES.CHATBOT_SCREEN && (
          <Dropdown title="Consultas">
            <SubItem>
              <UserButton
                isActive={pathname === USER_ROUTES.CHATBOT.path}
                onClick={() => history.push(USER_ROUTES.CHATBOT.path)}
              >
                {USER_ROUTES.CHATBOT.title}
              </UserButton>
            </SubItem>
          </Dropdown>
        )}

        <Dropdown title="Quejas y reclamos">
          <SubItem>
            <UserButton
              isActive={pathname === USER_ROUTES.COMPLAINTS.path}
              onClick={() => history.push(USER_ROUTES.COMPLAINTS.path)}
            >
              {USER_ROUTES.COMPLAINTS.title}
            </UserButton>
          </SubItem>
          <SubItem>
            <UserButton
              isActive={pathname === USER_ROUTES.CREATE_COMPLAINTS.path}
              onClick={() => history.push(USER_ROUTES.CREATE_COMPLAINTS.path)}
            >
              {USER_ROUTES.CREATE_COMPLAINTS.title}
            </UserButton>
          </SubItem>
        </Dropdown>
        <Authorization actions={["user.get_users"]}>
          <Dropdown title="Usuarios">
            <SubItem>
              <UserButton
                isActive={pathname === USER_ROUTES.USER_AGENT.path}
                onClick={() => history.push(USER_ROUTES.USER_AGENT.path)}
              >
                {USER_ROUTES.USER_AGENT.title}
              </UserButton>
            </SubItem>
          </Dropdown>
        </Authorization>
      </UnorderedList>
    </Container>
  );
}

export default UserSideMenu;
